// extracted by mini-css-extract-plugin
module.exports = {"header":"Homepage_header__3bBhJ","mainContentWrapper":"Homepage_mainContentWrapper__2ekuu","photoUpload":"Homepage_photoUpload__2rWsp"};